<template>
  <div class="doctorPage">
    <div class="centerHome">
      <div class="ccHomel">
        <div class="compentTable">
          <div class="info-card">
            <div class="date">{{ taskInfo.Name }}</div>
            <div class="line"></div>
            <div class="title">
              抽样类型：
              <span class="label">{{ taskInfo.CategoryName }}</span>
            </div>
          </div>
          <div class="func-bar">
            <div class="title">抽样报告(共{{ list.length }}份)</div>
            <el-button type="primary" @click="showSelectExpertDialog">重新分发</el-button>
          </div>
          <el-table 
            class="qcTable"
            ref="tableRef" 
            :data="list.slice((page - 1) * pageSize, page * pageSize)" 
            show-overflow-tooltip 
            v-loading="loading"
            :row-key="tableRowKey" 
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="80" :reserve-selection="true"></el-table-column>
            <el-table-column label="中心名称" prop="HospitalName" min-width="100"></el-table-column>
          	<el-table-column label="审核医生" prop="ModalityType" v-if="taskInfo.SubjectType == 2">
							<template slot-scope="scope">
								<span>{{scope.row.FirstApproverName}}</span>
							</template>
						</el-table-column>
						<el-table-column label="影像技师" prop="ModalityType" v-if="taskInfo.SubjectType == 3">
							<template slot-scope="scope">
								<span>{{scope.row.TechnictionName}}</span>
							</template>
						</el-table-column>
						<el-table-column label="诊断医生" prop="ModalityType" v-if="taskInfo.SubjectType == 4">
							<template slot-scope="scope">
								<span>{{scope.row.ReportSubmitterName}}</span>
							</template>
						</el-table-column>
            <el-table-column label="报告编码" prop="AccNo" min-width='150'></el-table-column>
            <el-table-column label="设备类型" prop="ModalityType" min-width='90'></el-table-column>
            <el-table-column label="检查项目" prop="CheckingItems" min-width='230'></el-table-column>
            <el-table-column prop="ReportScore" label="报告评分" key='1' v-if="taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ReportScoreDiff" label="报告分差" key='2' v-if="thisOnly&&(taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告')"></el-table-column>
						<el-table-column prop="ImageScore" label="影像评分" key='3' v-if="taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ImgScoreDiff" label="影像分差" key='4' v-if="thisOnly&&(taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告')"></el-table-column>
						<el-table-column prop="QCTimes" label="质控进度" key='5' v-if="thisOnly&&(taskInfo.DistributionMethod!=''&&taskInfo.DistributionMethod!='未知'&&taskInfo.DistributionMethod!='null')">
							<template slot-scope="scope">
								<el-tooltip effect="dark" placement="top-start">
									<div class="progress">
										<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100)}%`">
										</div>
										<span class="sr-only">{{(Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100))}}%</span>
									</div>
									<div slot="content" class="tableTooltip">
										<div>
											<em></em>
											<span>已完成数量:{{scope.row.CompleteCount}}</span>
										</div>
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
            <el-table-column prop="Status" label="质控状态" column-key='Status' min-width="100">
							<template slot-scope="scope">
								<div v-if="scope.row.TotalStatus == 0">
									<span>{{scope.row.Status | formatStatus}}</span>
								</div>
								<div v-else-if="scope.row.Status == 0">
									<span>{{scope.row.TotalStatus | formatStatus}}</span>
								</div>
							</template>
						</el-table-column>
            <el-table-column label="专家名称" prop="QCPeoPleName" min-width='90'></el-table-column>
            <el-table-column label="完成时间" prop="QCDt" min-width='150'></el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination 
              class="pageAll"
              layout="prev, pager, next"
              :total="list.length"
              :page-size='pageSize'
              :current-page='page' 
              @current-change='currentChange'
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog 
			title="选择专家"
			:visible.sync="selectExpertVisible"
			width="580px" 
			class="files-export-dialog"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
		>
			<template #footer>
				<el-button @click="selectExpertVisible = false">取消</el-button>
				<Button type="primary" :is-debounce="true" :loading="saveLoading" @click="confirmSelect">确定</Button>
			</template>
      <el-table 
        class="qcTable"
        ref="selectExpertTableRef" 
        :data="expertList" 
        show-overflow-tooltip 
      >
        <el-table-column label="" prop="select" width="80">
          <template slot-scope="scope">
            <el-radio
              v-model="selectExpertId"
              :label="scope.row.ExpertUserGuid"
              :disabled="selectRowsExpertUserGuids.includes(scope.row.ExpertUserGuid)"
            >
              {{ scope.row.name }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column label="专家姓名" prop="ExpertName" min-width="100"></el-table-column>
        <el-table-column label="备注" prop="remark" min-width="120">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              maxLength="30"
              :disabled="selectRowsExpertUserGuids.includes(scope.row.ExpertUserGuid)" 
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination 
          class="pageAll"
          layout="prev, pager, next"
          :total="expertList.length"
          :page-size='selectExpertParams.pageSize'
          :current-page='selectExpertParams.pageIndex' 
          @current-change='selectExpertPaginationChange'
        />
      </div>
		</el-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import axios from '@/js/api'
import Button from '@/components/Common/Button/index'
export default {
  components: { Button },
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      tableRowKey: 'ReportGuid',
      selectRows: [],
      selectRowsExpertUserGuids: [],
      selectExpertVisible: false,
      selectExpertParams: {
        pageIndex: 1,
        pageSize: 10
      },
      expertList: [],
      selectExpertId: '',
      expertUserId: '',
      saveLoading: false,
      thisOnly: false
    }
  },
  filters: {
    formatStatus: function(value) {
      return {
        '': '不限',
        '120': '已抽样',
        '123': '已分配',
        '125': '进行中',
        '130': '已完成',
        '140': '申诉中',
        '170': '已归档'
      } [value] || '不限';
    }
  },
  computed: {
    ...Vuex.mapState('managerPlanList', ['taskInfo', 'secondListFiltersStatus'])
  },
  activated() {
    this.init()
    const { expertUserId } = this.$route.query
    this.expertUserId = expertUserId
    this.getTaskDistributeListAndExpertList()
  },
  methods: {
    ...Vuex.mapMutations('breadcrumb', ['setqcresultsShow']),
    init() {
      this.page = 1
      this.selectExpertParams.pageIndex = 1
      this.selectRows = []
      this.selectRowsExpertUserGuids = []
      this.$refs.tableRef.clearSelection()
      this.saveLoading = false
      this.loading = false
      this.selectExpertVisible = false
    },
    // 获取任务分配列表和专家列表
    getTaskDistributeListAndExpertList() {
      this.list = []
      this.expertList = []
      this.loading = true
      axios.ajaxGet('get',Api.api.manager.getTaskDistributeList, {
        samplingTaskGuid: this.taskInfo.SamplingTaskGuid,
        expertUserId: this.expertUserId
      }).then(res=>{
        const { StatusCode, ExpertsInfoList = [], Reports = [] } =  Object(res.data)
        if (StatusCode === 200) {
          this.list = Reports
          this.expertList = ExpertsInfoList.map(item => ({ ...item, remark: '' }))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 表格分页参数改变
    currentChange(val) {
      this.page = val
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    // 表格选择项变化
    handleSelectionChange(row) {
      this.selectRows = row
      const list = this.selectRows.reduce((cur, item) => {
        return [...cur, ...item.ExpertUserGuids, ...item.ReportDistributionRecords]
      }, [])
      // console.log('list', list)
      this.selectRowsExpertUserGuids = Array.from(new Set(list))
    },
    // 显示选择专家弹窗
    showSelectExpertDialog() {
      if (this.selectRows.length <= 0) return this.$message.error('请先选择抽样报告数据')
      this.selectExpertId = ''
      this.expertList.forEach(item => {
        item.remark = ''
      })
      this.selectExpertVisible = true
    },
    // 选择专家分页变化
    selectExpertPaginationChange(val) {
      this.selectExpertParams.pageIndex = val
    },
    // 确定选择专家
    confirmSelect() {
      if (!this.selectExpertId) return this.$message.error('请选择专家')
      const { ExpertUserGuid, ExpertName, remark } = this.expertList.find(item => item.ExpertUserGuid === this.selectExpertId) || {}
      const reportExpertGuids = [], reportGuids = []
      this.selectRows.forEach(item => {
        reportExpertGuids.push(item.ReportExpertGuid)
        reportGuids.push(item.ReportGuid)
      })
      const params = {
        OutUserId: this.expertUserId,
        ReceiveUserId: ExpertUserGuid,
        ReceiveUserName: ExpertName,
        SamplingTaskGuid: this.taskInfo.SamplingTaskGuid,
        ReportExpertGuid: reportExpertGuids.join(','),
        ReportGuid: reportGuids.join(','),
        Note: remark
      }
      this.saveLoading = true
      axios.ajaxPost('post', Api.api.manager.saveTaskRedistribute, params).then(res=>{
        const { code, message } = Object(res.data.result)

        // console.log('xxxxxxx', res.data.result)

        if (code === 20000) {
          this.selectExpertVisible = false
          this.$router.back()
        } else {
          this.$message.error(message)
        }
      }).finally(() => {
        this.saveLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.compentTable {
  .info-card {
    display: flex;
    align-items: center;
    height: 30px;
    line-height: 30px;
    padding-bottom: 12px;
    .date {
      font-size: 16px;
      font-weight: 500;
    }
    .line {
      width: 1px;
      height: 14px;
      margin: 0 18px;
    }
    .title {
      font-size: 14px;
      font-weight: 300;
      .label {
        background: rgba(36,138,253,0.2);
        border-radius: 10px;
        border: 1px solid #248AFD;
        padding: 3px 10px;
      }
    }
  }
  .func-bar {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .el-button {
      margin-left: 24px;
    }
  }
}
::v-deep .files-export-dialog {
  .el-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
